import React from "react";
import { Form, Loader, Input, Select } from "semantic-ui-react";

// eslint-disable-next-line react/display-name
export const textInputRender = (label: string, placeholder: any, required = false) => ({
  input,
  meta
}: any) => (
  <>
    <label style={{ display: "block", marginBottom: "8px" }}>
      <b>{label}</b>
      {required && <sup style={{ color: "red" }}>*</sup>}
      {meta.validating && (
        <Loader style={{ float: "right" }} className="workaround" size="mini" active inline />
      )}
    </label>
    <Form.Input
      error={
        (meta.touched || !meta.pristine) &&
        meta.error && {
          content: meta.error,
          pointing: "below"
        }
      }
      required={required}
      placeholder={placeholder}
      name={input.name}
      value={input.value}
      onBlur={input.onBlur}
      onFocus={input.onFocus}
      onChange={input.onChange}
    />
  </>
);

// Note: When typing, label should be optional
export const TextInput = ({ meta, label, input: { onChange, ...input }, ...rest }: any) => {
  return (
    <Form.Field
      error={
        ((meta.touched || !meta.pristine) &&
          meta.error && {
            content: meta.error
          }) ||
        (meta.dirty &&
          meta.dirtySinceLastSubmit &&
          meta.submitError && {
            content: meta.submitError
          })
      }
      control={Input}
      label={
        <label>
          {label}
          {meta.validating && (
            <Loader style={{ float: "right" }} className="workaround" size="mini" active inline />
          )}
        </label>
      }
      {...input}
      onChange={(_: any, { value }: any) => onChange(value)}
      {...rest}
    />
  );
};
export const SelectInput = ({
  input: { onChange, ...input },
  meta,
  label,
  options = [],
  ...rest
}: any) => (
  <Form.Field
    error={
      ((meta.touched || !meta.pristine) &&
        meta.error && {
          content: meta.error,
          pointing: "below"
        }) ||
      (meta.dirty &&
        meta.dirtySinceLastSubmit &&
        meta.submitError && {
          content: meta.submitError,
          pointing: "below"
        })
    }
    control={Select}
    label={
      <label>
        {label}
        {meta.validating && (
          <Loader style={{ float: "right" }} className="workaround" size="mini" active inline />
        )}
      </label>
    }
    {...input}
    onChange={(_: any, { value }: any) => onChange(value)}
    options={options === null ? [] : options}
    {...rest}
  />
);
